import { MutationTree } from 'vuex';
import { AppointmentState } from './types';
import { AppointmentInfo, CreateAppointmentStatus } from '@/models';

export const mutations: MutationTree<AppointmentState> = {
  STORE_SEARCH_START_DATE(state, data: Date) {
    state.searchStartDate = data
  },
  STORE_APPOINTMENT_INFO(state, data: AppointmentInfo) {
    state.appointment = data
  },
  STORE_CREATE_APPOINTMENT_STATUS(state, data: CreateAppointmentStatus) {
    state.status = data
  },
  CLEAR(state) {
    state.appointment = null
    state.searchStartDate = null
  }
}
